export default class AutomationCtrl {
    constructor($scope, $state, $stateParams, $q, $filter, $rootScope, $timeout, Automation, Events, Customization, SideMenu, Segment, Tag) {
        SideMenu.setActive('automation');

        this._stateParams = $stateParams;
        this._filter = $filter;
        this._timeout = $timeout;
        this._q = $q;
        this._rootScope = $rootScope;
        this._scope = $scope;
        this._state = $state;

        this.automationRepo = Automation;
        this.eventHandler = Events;
        this.tagRepo = Tag;
        this.segmentRepo = Segment;
        this.customizationRepo = Customization;

        this.customDateFields = [];
        this.showActive = this._stateParams.folder ? this._stateParams.folder == 'active' : true;
        this.loading = false;
        this.search = "";
        this.currentPage = 1;
        this.searchTimeout = false;

        this.tagRepo.all().then((result) => {
            this.tags = result.data;
            this.segmentRepo.all().then((result) => {
                this.segments = result.data;
            });
        });

        this.customizationRepo.allGroups().then((groups) => {
            angular.forEach(groups.data, (group) => {
                angular.forEach(group.fields, (field) => {
                    if (field.type == 'date') {
                        field.groupName = group.name;
                        this.customDateFields.push(field);
                    }
                });
            });
        });

        this._scope.$watch(() => this.currentPage, (toPage) => {
            if (toPage && ! this.loading) {
                this.setPage(this._q.defer());
            }
        });

        var newAutomationListener = this._rootScope.$on('automation:newAutomation', () => {
            this.createAutomation();
        });
        var reloadListener = this._scope.$on('automation:switchStatus', () => {
            this.switchStatus();
        });
        var removedAutomationListener = this._scope.$on('automation:removed', () => {
            this.setPage(this._q.defer());
        });

        this._scope.$on('$destroy', newAutomationListener);
        this._scope.$on('$destroy', reloadListener);
        this._scope.$on('$destroy', removedAutomationListener);

    }

    setPage(deferred) {
        this.loading = true;

        this.automationRepo.all(this.showActive, this.currentPage).then((response) => {
            this.automations = this._filter('orderBy')(response.data, 'name');
            this.metaData = response.meta.pagination;
            this.loading = false;

            if (this.currentPage > this.metaData.total_pages && this.metaData.total_pages != 0) { // If outside of page-range.
                this.currentPage = this.metaData.total_pages;
            }

            this.statusCounts(deferred);
        });

        return deferred.promise;
    };

    addAutomation(newAutomation) {
        let moved = false;

        angular.forEach(this.automations, (automation, index) => {
            if (automation.id == newAutomation.data.id && ! moved) {
                this.automations.unshift(newAutomation.data);
                this.automations.splice(++index, 1);
                moved = true;
            } else if (index == (this.automations.length - 1) && ! moved) { // Not on page 1..
                this.automations.unshift(newAutomation.data); // Add to top.
                this.automations.splice(index - 1, 1); // Remove last automation.
                moved = true;
            }
        });

        this.eventHandler.flashEvent('notification', this._filter('translate')('AUTOMATION:FLASH:AUTOMATION_CREATED'));

        this._timeout(() => {
            $('.automation').first().find('.automation-name-input').first().focus(); // Focus name input
            this.newAutomationFlash(19);
        });
    };

    setActive(active) {
        if (active == this.showActive) {
            return;
        }

        var deferred = this._q.defer();
        this.showActive = active;
        this.search = "";
        this._state.go('automation.folder', { folder: this.showActive ? 'active' : 'inactive' }, { notify: false });
        this.currentPage != 1 ? this.currentPage = 1 : this.setPage(deferred);

        return deferred.promise;
    };

    statusCounts(deferred) {
        this.automationRepo.statusCounts().then((counts) => {
            this.counts = counts;

            if (deferred) {
                deferred.resolve();
            }
        });
    };

    hasAutomations() {
        if (! this.automations) {
            return true;
        } else if (! this.automations.length) {
            return false;
        } else {
            var hasAutomations = false;
            angular.forEach(this.automations, (automation) => {
                if (! automation.removed) {
                    hasAutomations = true;
                }
            });

            return hasAutomations;
        }
    };

    newAutomationFlash(numIterations) {
        this._timeout(() => {
            $('.automation').first().toggleClass('green-border');

            if (numIterations > 0) {
                this.newAutomationFlash(numIterations - 1);
            }
        }, 500);
    };

    createAutomation() {
        if (this.currentPage != 1) {
            this.currentPage = 1;
        }

        return this.automationRepo.create().then((automation) => {
            if (this.showActive) {
                this.setActive(false).then(() => {
                    this.addAutomation(automation);
                });
            } else {
                this.setPage(this._q.defer()).then(() => {
                    this.addAutomation(automation);
                });
            }
        });
    };

    searchAutomations() {
        this.currentPage = 1;

        this.automations = [];
        this.loading = true;

        if (this.searchTimeout) {
            this._timeout.cancel(this.searchTimeout);
        }

        this.searchTimeout = this._timeout(() => {
            if (this.search == "") {
                this.setPage();
            } else {
                this.automationRepo.search(this.search).then((response) => {
                    this.loading = false;
                    this.automations = response.data;
                    this.metaData.total = this.metaData.per_page = this.searchCount = response.data.length;
                });
            }
        }, 500);
    };

    switchStatus() {
        this.setActive(! this.showActive);
    };

    clearSearch() {
        this.search = "";
        this.searchCount = 0;
        this.currentPage = 1;
        this.automations = [];
        this.setPage();
    };
}
